import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
                        <div className="consider_content">
                                <h2>When to Consider Our Custom Software Development Services</h2>
                               <p>We provide strong software solutions for organizations of all sizes, quickly and with the utmost attention to quality, ROI, and your users.</p>
                            <p>Achieve success with our customized software solutions, crafted exclusively for your business needs.  Here’s when you should consider our software development services:</p>
                            <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let’s Build Your Custom Software!</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
                    <div className="consider-box">
                        <h6>Launching a New App</h6>
                        <p>If you're launching something new, such as your own app, our software development solutions may give your idea a personal touch, assuring a memorable launch.</p>
                    </div>
                    <div className="consider-box">
                        <h6>Revamping an Existing App</h6>
                        <p>Refresh your current app with advanced features and functionalities. Our custom software development services revitalize your app, ensuring modernization and increased user engagement.</p>
                    </div>
                    <div className="consider-box">
                        <h6>Adopting Cross-Platform Development</h6>
                        <p>If you're ready to expand the reach of your software, choose cross-platform development with us. We help you broaden the reach of your app.</p>
                    </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Considerapp